/**
 * Actualiza todas las barras de progreso de envío gratis en la página
 * @param {number} cartTotal - Total del carrito en centavos
 */

/**
 * Formatea un precio para mostrar decimales solo cuando sea necesario
 * @param {number} price - Precio en pesos
 * @returns {string} Precio formateado
 */
function formatPrice(price) {
  const formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
  return formatter
    .format(price)
    .replace(/[^\d.,]/g, '')
    .trim()
}

window.updateFreeShippingProgress = function (cartTotal = 0, hasFreeShippingProduct = null) {
  const progressBars = document.querySelectorAll('.free-shipping-progress')

  progressBars.forEach((progressBar) => {
    const threshold = parseInt(progressBar.dataset.freeShippingThreshold || 10000)
    const currentTotal = cartTotal

    const hasFreeShipping = hasFreeShippingProduct !== null
      ? hasFreeShippingProduct
      : progressBar.dataset.hasFreeShippingProduct === 'true'

    const remaining = Math.max(0, threshold - currentTotal)
    const progressPercentage = hasFreeShipping ? 100 : Math.min(100, Math.max(0, (currentTotal / threshold) * 100))

    const messageElement = progressBar.querySelector('[data-shipping-message]')
    const progressBarElement = progressBar.querySelector('[data-progress-bar]')

    if (messageElement) {
      if (hasFreeShipping) {
        messageElement.innerHTML = `¡Tienes <span class="font-bold text-primary">envío gratis</span>! 🎉`
      } else if (remaining > 0) {
        const remainingDollars = remaining / 100
        const formattedRemaining = formatPrice(remainingDollars)
        messageElement.innerHTML = `Te faltan solo <span class="font-bold text-primary">$${formattedRemaining}</span> para tener ¡envío gratis!`
      } else {
        messageElement.innerHTML = `¡Tienes <span class="font-bold text-primary">envío gratis</span>! 🎉`
      }
    }

    if (progressBarElement) {
      progressBarElement.style.width = `${progressPercentage}%`
    }

    progressBar.dataset.currentTotal = currentTotal
  })
}

function checkForFreeShippingProduct(items) {
  return items.some(item => {
    // Verificar por property _free_shipping (agregada al carrito)
    if (item.properties && item.properties._free_shipping === 'true') {
      return true
    }
    // Fallback: verificar por handles conocidos
    const freeShippingHandles = window.freeShippingProductHandles || []
    return freeShippingHandles.includes(item.handle)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      window.cartSubtotal = cart.total_price || 0
      const hasFreeShipping = checkForFreeShippingProduct(cart.items || [])
      window.updateFreeShippingProgress(window.cartSubtotal, hasFreeShipping)
    })
    .catch((err) => {
      console.error('Error al cargar el carrito:', err)
      window.updateFreeShippingProgress(0)
    })
})

document.addEventListener('cart:updated', (e) => {
  if (e.detail && e.detail.cart) {
    window.cartSubtotal = e.detail.cart.total_price || 0
    const hasFreeShipping = checkForFreeShippingProduct(e.detail.cart.items || [])
    window.updateFreeShippingProgress(window.cartSubtotal, hasFreeShipping)
  }
})

document.addEventListener('cart:quantity-changed', (e) => {
  if (e.detail && e.detail.cart) {
    window.cartSubtotal = e.detail.cart.total_price || 0
    const hasFreeShipping = checkForFreeShippingProduct(e.detail.cart.items || [])
    window.updateFreeShippingProgress(window.cartSubtotal, hasFreeShipping)
  }
})
